module.exports = __webpack_public_path__ + "img/address.77045b7a.svg";